import { HttpClient } from '@angular/common/http';
import { Component, OnInit, signal, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

import { IconComponent, ObserveIntersectingDirective } from '@factor_ec/ui';

import { AppService } from '@/core/app.service';

/**
 * @description Componente para mostrar páginas estáticas del sistema
 * @class PageComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'app-page',
  imports: [
    MatButtonModule,
    MatDialogModule,
    IconComponent,
    ObserveIntersectingDirective
  ],
  templateUrl: './page.component.html',
  styleUrl: './page.component.scss'
})
export class PageComponent implements OnInit {
  // Dependency injection
  appService = inject(AppService);
  data = inject(MAT_DIALOG_DATA);
  private httpClient = inject(HttpClient);

  // Properties
  page = signal<any>(undefined);
  loading = signal<boolean>(false);

  /**
   * @description Inicializa el componente
   * @implements OnInit
   */
  ngOnInit(): void {
    this.httpClient.get(this.data.url).subscribe(response => {
      this.page.set(response);
    });
  }
}
